import * as React from 'react';
import { EditModeEnum } from '../interfaces/state';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';
import { GlobalHotKeys } from 'react-hotkeys';
import { OnIgnoreEnter } from '../AnalyseApp';

interface DeleteEventButtonProps {
    isEditMode: EditModeEnum;
    isKeyboardShortcutVisible: boolean;
    onDeletePointClick: () => void;
    onDeletePeriodClick: () => void;
}

export const DeleteEventButton = ({ isEditMode, isKeyboardShortcutVisible, onDeletePointClick, onDeletePeriodClick }: DeleteEventButtonProps) => {
    const onDeleteClick = () => {
        if (isEditMode == EditModeEnum.EditingPoint) {
            onDeletePointClick();
        }

        if (isEditMode == EditModeEnum.EditingPeriod) {
            onDeletePeriodClick();
        }
    }

    if (isEditMode !== EditModeEnum.NotEditing) {
        const keyMap = {
            deleteEvent: 'delete',
        }

        const handlers = {
            'deleteEvent': () => onDeleteClick(),
        }

        return (
            <>
                <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
                <button id="DeleteEvent" className="btn btn-danger" type="button" onClick={() => onDeleteClick()} onKeyDown={OnIgnoreEnter}>
                    <i className="fas fa-trash fa-fw" aria-hidden="true"></i>&nbsp;
                    Delete
                    &nbsp;
                        <KeyboardShortcutTooltip key="KeyTooltip" show={isKeyboardShortcutVisible} keyName="DELETE" />
                </button>
            </>
        );
    } else {
        return null;
    }
}
